import { useState } from "react";
import { FAQPageJsonLd } from 'next-seo';

function Accordion() {
    const [activeDefault, setActiveDefault] = useState(0);
    const defaultAccordion = [
        {
            title: "ما هي الخطوات التي تتخذها شركة ايسمارت أمن وخصوصية البيانات؟",
            text:
                "تتخذ شركة ايسمارت إجراءات صارمة لضمان أمن وخصوصية جميع البيانات التي تتم معالجتها أو تخزينها معنا. نحن نستخدم بروتوكولات التشفير المعيارية للصناعة والتدابير الأخرى لحماية معلوماتك.",
            bg: "primary",
        },
        {
            title: "ماذا علي أن أفعل إذا كنت أرغب في الاشتراك بتطبيق ايسمارت؟",
            text:
                "إذا كنت مهتمًا بالاشتراك بالتطبيق كل ما عليك هو تسجيل بيانات ليقومو ممثلو المبيعات التواصل معك وتقديم الخدمات التى تحتاجها ،فيرجى الاتصال بنا مباشرةً للحصول على مزيد من المعلومات حول الخطوات المطلوبة.",
            bg: "info",
        },
        {
            title: "كيف يمكنني الاتصال بالدعم الفني؟",
            text:
                "يتوفر فريق دعم العملاء لدينا على مدار الساعة طوال أيام الأسبوع لمساعدتك في أي أسئلة أو مشكلات قد تكون لديك. يمكنك الاتصال بنا عبر البريد الإلكتروني على support@esmart.com.sa أو عبر الهاتف على 050  444 9747 او على الوتس اب من خلال الرابط التالي <a href='https://api.whatsapp.com/send?phone=966504449747' target='_blank'>https://api.whatsapp.com/send?phone=966504449747</a>",
            bg: "info",
        },
    ];
  return (
    <>
    
			<FAQPageJsonLd
				mainEntity={defaultAccordion.map((item)=>{
					return {
						questionName: item.title,
						acceptedAnswerText: item.text,
					}
				})}
				/>
        <div
            className="dlab-accordion"
            id="accordionFaq"
            defaultactivekey="0"
        >
            {defaultAccordion.map((d, i) => (
                <div className="card" key={i}>
                    <div
                        eventkey={`${i}`}
                        className="card-header"
                        onClick={() =>
                            setActiveDefault(activeDefault === i ? -1 : i)
                        }
                    >
                        <h2 className="h5 dlab-title">
                            <a 
                                className={`${
                                    activeDefault === i ? "" : "collapsed"
                                }`}
                                onClick={() =>
                                    setActiveDefault(
                                        activeDefault === i ? -1 : i
                                    )
                                }
                            >
                                {" "}
                                {d.title}
                            </a>
                        </h2>
                    </div>
                    {/* <div className="collapse show" eventkey={`${i}`}>
                        <div className="card-body">
                            <p className="m-b0">{d.text}</p>
                        </div>
                    </div> */}
                    <div className={`${
							activeDefault === i ? "collapsed show" : "collapsed"
						}`} eventkey={`${i}`} onClick={() =>
							setActiveDefault(
								activeDefault === i ? -1 : i
							)
						}
					>
                        <div className="card-body">
                            <p className="m-b0" dangerouslySetInnerHTML={{__html: d.text}} ></p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </>
  )
}

export default Accordion;